import { useState } from 'react';
import { SatisfactionSurveyFrequencyType } from '../../services/modules/satisfactionSurveySettings/satisfactionSurveyFrequencyType.enum';
import { useUpdateSatisfactionSurveySettings } from '../../services/modules/satisfactionSurveySettings/satisfactionSurveySettings.mutations';
import { useFindSatisfactionSurveySettings } from '../../services/modules/satisfactionSurveySettings/satisfactionSurveySettings.queries';
import {
  SatisfactionSurveyAudience,
  SatisfactionSurveySettings,
} from '../../services/modules/satisfactionSurveySettings/satisfactionSurveySettings.types';
import { OrderType } from '../orders/interfaces/orderType.enum';
import { DEFAULT_FREQUENCY_LAST_DAYS } from './hooks/useSatisfactionSurveyFrequencyFields';

export const satisfactionSurveySettingsDefault: SatisfactionSurveySettings = {
  id: null,
  enabled: false,
  url: null,
  message: null,
  orderType: OrderType.PRE_ORDER,
  audiences: Object.values(SatisfactionSurveyAudience),
  frequencyType: SatisfactionSurveyFrequencyType.ORDER_COLLECTION,
  frequencyLastDays: DEFAULT_FREQUENCY_LAST_DAYS,
};

const useSatisfactionSurveySettings = () => {
  const { data, isLoading, isError, queryKey } = useFindSatisfactionSurveySettings();

  const [rejectedSaves, setRejectedSaves] = useState(0);

  const { mutate, isPending } = useUpdateSatisfactionSurveySettings({
    queryKey,
    onError: () => setRejectedSaves((current) => current + 1),
  });

  return {
    settings: data ?? satisfactionSurveySettingsDefault,
    isDisabled: isLoading || isError,
    isError,
    isSaving: isPending,
    rejectedSaves,
    onChange: mutate,
  };
};

export default useSatisfactionSurveySettings;
